//GeneratorFlag:[NoChange]
import LetterPattern from './letter-pattern';
import LetterPatternFilter from './letter-pattern-filter';

export default {LetterPattern, LetterPatternFilter}
export{LetterPattern, LetterPatternFilter}